module.exports = __webpack_public_path__ + "media/img/uploads/solutions-tall-thumb-01-8d80ed646b5091313f0b79498c3b1cb6.jpg";